import { render, staticRenderFns } from "./FormIRTC.vue?vue&type=template&id=e3f6e7bc&scoped=true&"
import script from "./FormIRTC.vue?vue&type=script&lang=js&"
export * from "./FormIRTC.vue?vue&type=script&lang=js&"
import style0 from "./FormIRTC.vue?vue&type=style&index=0&id=e3f6e7bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f6e7bc",
  null
  
)

export default component.exports